<template>
  <div class="guest guest-content wd-1200">

    <moduleTitle :large="large" :moduleFlag="moduleFlag" />

    <div class="guest-content-box" :class="{ 'flex-layout': isMore }">
      <div class="guest-content-box-item" :class="{ 'float-item': !isMore }" v-for="(item, index) in moduleInfo" :key="index" @click="handleClick(item)">
        <div class="guest-content-item-img">
          <img :src="item.image"/>
        </div>
        <div class="guest-content-item-name">
          <span>{{ item.name }}</span>
        </div>
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="show"
      custom-class="guest-detail-dialog"
      width="730px"
      @close="handleCloseDialog">
      <div v-if="checkItem.displayStyle === 1" class="detail-iamge-style">
        <img :src="checkItem.detailImage">
      </div>
      <div v-if="checkItem.displayStyle === 0" class="guest-dialog">
        <div class="guest-dialog-top">
          <div class="guest-dialog-top-img">
            <img :src="checkItem.image"/>
          </div>
          <div class="guest-dialog-top-message">
            <div class="guest-dialog-top-message-name">{{ checkItem.name }}</div>
            <div class="guest-dialog-top-message-position">{{ checkItem.title }}</div>
            <div class="guest-dialog-top-message-company">{{ checkItem.company }}</div>
            <div class="guest-dialog-top-message-dept">{{ checkItem.dept }}</div>
            <div class="guest-dialog-content" v-html="checkItem.introduce">{{ checkItem.introduce }}</div>
          </div>

        </div>
      </div>
    </el-dialog>

    <div class="more" style="margin-top: 0" v-if="isMore">
      <span @click="handleMore">查看更多</span>
    </div>
  </div>
</template>

<script>
  import moduleTitle from '@/components/pc/module-title';

  export default {
    components: { moduleTitle },
    props: {
      moduleInfo: {
        type: Array,
        default: () => [],
      },
      moduleFlag: {
        type: String,
        default: '',
      },
      isMore: {
        type: Boolean,
        default: true
      },
      large: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        show: false,
        checkItem: {}
      };
    },
    methods: {
      handleClick(item) {
        this.checkItem = item
        this.show = true
      },
      handleCloseDialog() {
        this.show = false
      },
      handleMore() {
        this.$router.push({ 
          name: 'guest',
          params: {
            moduleIndex: this.moduleFlag.split('_')[1]
          }
        })
      }
    },
    created() {

    },
  }
</script>

<style lang="scss">
  .guest-content {
    .detail-iamge-style{
      img{
        width:100%;
        height:100%;
      }
    }
    .guest-content-box {
      overflow: hidden;

      .guest-content-box-item {
        width: 224px;
        height: 296px;
        margin: 0 20px 30px 0;

        .guest-content-item-img {
          width: 224px;
          height: 224px;

          img {
            width: 100%;
            height: 100%;
            display: inline-block;
            cursor: pointer;
          }
        }

        .guest-content-item-name {
          height: 80px;
          text-align: center;
          line-height: 80px;
          background: #f5f5f5;
          font-size: 16px;
          &:hover {
            cursor: pointer;
            color: var(--themeColor);
          }
        }
      }

      .guest-content-box-item:nth-child(5n) {
        margin-right: 0;
      }
    }

    .flex-layout {
      display: flex;
      flex-flow: wrap;
      flex-direction: row;
      justify-content: center;
    }

    .float-item {
      float: left;
    }

    .guest-detail-dialog {
      max-height: 650px;
      overflow-y: auto;

      /*.el-dialog__header {*/
      /*  padding: 0 !important;*/
      /*}*/
    }

    .guest-dialog {

      .guest-dialog-top {
        overflow: hidden;

        .guest-dialog-top-img {
          float: left;
          margin-right: 20px;

          img {
            width: 186px;
            height: 186px;
          }
        }

        .guest-dialog-top-message {
          color: #333;
          margin-left: 20px;
          overflow: hidden;

          .guest-dialog-top-message-name {
            font-size: 20px;
            line-height: 24px;
            font-weight: bold;
            padding-bottom: 14px;
          }

          .guest-dialog-top-message-position {
            font-size: 16px;
            padding-bottom: 16px;
          }

          .guest-dialog-top-message-company, .guest-dialog-top-message-dept {
            font-size: 16px;
            padding-bottom: 16px;
          }

          .guest-dialog-content {
            width: 100%;
            font-size: 14px;
            color: #999;
            line-height: 24px;
            text-indent: 24px;

            p {
              margin: 0;
            }
          }
        }
      }
    }
  }
</style>